import { ADD_NAME, REMOVE_NAME } from './types'

export const addUserName = (name: string) => ({ type: ADD_NAME, name: name })

export const removeUserName = () => ({ type: REMOVE_NAME })